import { useLocalization } from "@fluent/react"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import { Button, IconButton, Tooltip } from "@mui/material"
import { useNavigate } from "react-router-dom"
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded"

type OpenMeetingMinutesButtonProps = {
    meetingMinutesId: string | null
    agendaItemId?: number | null
    compact?: boolean
    iconOnly?: boolean
}

export const OpenMeetingMinutesButton = ({ meetingMinutesId, agendaItemId, compact = false, iconOnly = false }: OpenMeetingMinutesButtonProps) => {
    const { l10n } = useLocalization()
    const navigate = useNavigate()
    const canOpen = Boolean(meetingMinutesId?.trim())
    const openLabel = l10n.getString("operational-dashboard-open-mm", null, "_Otwórz w Meeting Minutes")
    const openMeetingMinutes = () => {
        if (meetingMinutesId?.trim()) {
            const url = `/operational-dashboards/meeting-minutes/edit/${encodeURIComponent(meetingMinutesId)}`
            navigate(agendaItemId != null ? `${url}?agendaItemId=${encodeURIComponent(agendaItemId)}` : url)
        }
    }

    return (
        <Tooltip title={canOpen
            ? iconOnly ? openLabel : ""
            : l10n.getString("operational-dashboard-meeting-minutes-open-unavailable", null, "_Brak protokołu spotkania do otwarcia.")}>
            <span style={{ display: compact || iconOnly ? "inline-block" : "block" }}>
                {iconOnly ? (
                    <IconButton size="small" disabled={!canOpen} onClick={openMeetingMinutes} aria-label={openLabel}>
                        <OpenInNewIcon fontSize="small" />
                    </IconButton>
                ) : (
                    <Button variant={compact ? "text" : "contained"} fullWidth={!compact} disabled={!canOpen}
                        startIcon={compact ? <ArrowForwardRoundedIcon fontSize="small" /> : undefined}
                        endIcon={compact ? undefined : <ArrowForwardIcon />} onClick={openMeetingMinutes}>
                        {compact
                            ? l10n.getString("operational-dashboard-open-mm-short", null, "_Otwórz w MM")
                            : openLabel}
                    </Button>
                )}
            </span>
        </Tooltip>
    )
}
